export default "__VITE_ASSET__6osOleF0__"